// Tiny fetch wrapper. All admin calls are cookie-authenticated; we just
// need credentials: "include" so the session cookie is sent on every hop.

async function request(method, path, body) {
    const res = await fetch(path, {
        method,
        credentials: "include",
        headers: body !== undefined ? { "content-type": "application/json" } : undefined,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    let data = null;
    const text = await res.text();
    if (text) {
        try { data = JSON.parse(text); } catch { data = { error: text }; }
    }
    if (!res.ok) {
        const err = new Error(data?.error || `HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

export const api = {
    get:  (path)             => request("GET",    path),
    post: (path, body = {})  => request("POST",   path, body),
    del:  (path)             => request("DELETE", path),
};

export function queryString(obj) {
    const p = new URLSearchParams();
    for (const [k, v] of Object.entries(obj)) {
        if (v === undefined || v === null || v === "") continue;
        p.set(k, String(v));
    }
    const s = p.toString();
    return s ? `?${s}` : "";
}
